"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var modal_1 = require("../../../component/modal");
var Icon = (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "20", viewBox: "0 0 24 24", width: "20" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
    react_1.default.createElement("circle", { cx: "19.5", cy: "19.5", r: "1.5" }),
    react_1.default.createElement("path", { d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z" })));
var enableNodes = [/header\d?/, /list_item/];
var AnchorSettingModal = function (_a) {
    var _b = _a.id, id = _b === void 0 ? '' : _b, _c = _a.visible, visible = _c === void 0 ? false : _c, onCancel = _a.onCancel, onOk = _a.onOk, editor = _a.editor;
    var _d = react_1.useState(id), value = _d[0], setValue = _d[1];
    var setAnchor = function () {
        onOk(value);
        onCancel();
    };
    react_1.useEffect(function () {
        setValue(id);
    }, [visible]);
    var locale = editor.configurator.getLocaleValue('anchor');
    return (react_1.default.createElement(modal_1.Modal, { isOpen: visible, onClose: onCancel },
        react_1.default.createElement(modal_1.ModalTitle, null, locale.anchorTitle || '设置锚点'),
        react_1.default.createElement(modal_1.ModalContent, null,
            react_1.default.createElement("input", { value: value || '', onChange: function (e) { return setValue(e.target.value); }, placeholder: locale.anchorNamePlaceholder || '请输入锚点名' })),
        react_1.default.createElement(modal_1.ModalFooter, null,
            react_1.default.createElement("button", { onClick: onCancel, type: "button" }, locale.cancelText || '取消'),
            react_1.default.createElement("button", { onClick: setAnchor, type: "button" }, locale.okText || '确定'))));
};
var AnchorUtil = /** @class */ (function () {
    function AnchorUtil(editor) {
        var _this = this;
        this.name = 'anchor';
        this.icon = Icon;
        this.nodePos = 0;
        this.disable = function (editor) {
            var cursorNode = editor.getCursorNode();
            if (!cursorNode)
                return true;
            if (enableNodes.some(function (reg) { return reg.test(cursorNode.node.type.name); })) {
                return false;
            }
            return true;
        };
        this.closeModal = function () {
            _this.renderModal(false);
        };
        this.updateId = function (id) {
            _this.editor.updateCardAttrs(_this.nodePos, { id: id });
            requestAnimationFrame(function () { return _this.editor.focus(); });
        };
        this.renderModal = function (visible, id) {
            if (id === void 0) { id = ''; }
            if (visible) {
                _this.editor.blur();
            }
            react_dom_1.default.render(react_1.default.createElement(AnchorSettingModal, { visible: visible, id: id, onCancel: _this.closeModal, onOk: _this.updateId, editor: _this.editor }), _this.dom);
        };
        this.handler = function (editor) {
            var cursorNode = editor.getCursorNode();
            if (!cursorNode)
                return;
            _this.nodePos = cursorNode.pos;
            var id = cursorNode.node.attrs.id;
            _this.renderModal(true, id);
        };
        this.editor = editor;
        this.dom = document.createElement('div');
        document.body.appendChild(this.dom);
    }
    return AnchorUtil;
}());
exports.AnchorUtil = AnchorUtil;
//# sourceMappingURL=anchor-util.js.map